import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  
    events: []
  },
  mutations: {
    ADD_EVENT(state, payload) {
      state.config.events.push(payload);
    }
  },
  actions: {
    addEvent({ commit }, payload) {
      commit('ADD_EVENT', payload);
    }
  },
  getters: {
    /* getConfig(state) {
      return state.config;
    }, */
    getEvents(state) {
      return state.config.events;
    }
  }
})
